import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  AutoCheckinMode,
  ClassBookingConfig,
} from '../../model/class-booking-config';

@Component({
  selector: 'gymfinder-class-booking-config',
  templateUrl: './class-booking-config.component.html',
  styleUrls: ['./class-booking-config.component.scss'],
  standalone: false,
})
export class ClassBookingConfigComponent {
  @Input() classBookingConfig: ClassBookingConfig;

  readonly AutoCheckinMode = AutoCheckinMode;
  // TODO(WPAEX-1899): remove env flag and enable on Prod upon release
  readonly showSkipCheckinRequiredForMmsAccess =
    environment.showSkipCheckinRequiredForMmsAccess;

  handleOnAutoCheckinModeChange(mode: AutoCheckinMode): void {
    this.classBookingConfig.autoCheckinMode = mode;
  }

  handleOnCreateMemberAccountForCheckinChange(checked: boolean): void {
    this.classBookingConfig.createMemberAccountForCheckin = checked;

    if (!checked) {
      this.classBookingConfig.hasAccessPass = false;
    }
  }
}
